import DialogActions from '@material-ui/core/DialogActions';
import React from 'react';

export const ModalActions = ({ children }: { children: React.ReactNode }) => {
  return <DialogActions>{children}</DialogActions>;
};
